var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "flex flex-col w-full h-72 bg-white border border-gray-200 rounded-xl overflow-hidden"
  }, [_c('div', {
    staticClass: "px-4 py-3 border-b border-gray-200"
  }, [_c('h3', {
    staticClass: "text-base font-medium mb-0",
    class: _vm.theme.titleClass
  }, [_vm._v(_vm._s(_vm.theme.title))])]), _vm.isLoading ? _c('div', {
    staticClass: "relative h-50 flex-1 bg-white"
  }, [_c('div', {
    staticClass: "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col items-center"
  }, [_c('svg', {
    staticClass: "h-26 w-16 animate-spin text-blue-600 mb-4",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('circle', {
    staticClass: "opacity-25",
    attrs: {
      "cx": "12",
      "cy": "12",
      "r": "10",
      "stroke": "currentColor",
      "stroke-width": "2"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 2 A 10 10 0 0 1 22 12",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  })])])]) : _c('div', {
    staticClass: "grid grid-cols-2 flex-1"
  }, [_c('div', {
    staticClass: "relative overflow-hidden flex flex-col items-center text-center px-4 py-6",
    class: {
      'justify-center': !_vm.topItem
    }
  }, [_c('span', {
    staticClass: "absolute -left-10 -bottom-12 w-40 h-40 rounded-full",
    class: _vm.theme.circleClass
  }), _c('span', {
    staticClass: "absolute left-16 -bottom-20 w-36 h-36 rounded-full opacity-50",
    class: _vm.theme.softCircleClass
  }), !_vm.topItem ? _c('div', {
    staticClass: "relative z-10 flex flex-col items-center gap-2"
  }, [_vm.variant === 'purchase' ? _c('ChartMixedDollarFilled', {
    attrs: {
      "className": "w-16 h-16 text-gray-400"
    }
  }) : _c('i', {
    staticClass: "text-5xl text-gray-400",
    class: _vm.theme.icon
  }), _c('p', {
    staticClass: "text-sm font-semibold text-gray-500 mb-0"
  }, [_vm._v("No Data Available")])], 1) : _c('div', {
    staticClass: "relative z-10 flex flex-col items-center w-full min-w-0"
  }, [_c('p', {
    staticClass: "flex items-center text-base font-semibold mb-0",
    class: _vm.theme.metricClass
  }, [_vm.variant === 'purchase' ? _c('ChartMixedDollarFilled', {
    attrs: {
      "className": "w-4 h-4 mr-1 text-current"
    }
  }) : _c('i', {
    staticClass: "mr-1",
    class: _vm.theme.icon
  }), _vm._v(" " + _vm._s(_vm.formatNumber(_vm.topItem.total)) + " " + _vm._s(_vm.theme.unit) + " ")], 1), _c('p', {
    staticClass: "text-xs text-gray-500 mb-0"
  }, [_vm._v(" from a total of " + _vm._s(_vm.formatNumber(_vm.total)) + " " + _vm._s(_vm.theme.totalUnit) + " ")]), _c('div', {
    staticClass: "relative mt-4 mb-2"
  }, [_c('span', {
    staticClass: "absolute -left-8 bottom-0 text-7xl font-bold leading-none text-gray-300 select-none"
  }, [_vm._v("1")]), _c('img', {
    staticClass: "relative h-20 w-14 object-cover rounded",
    attrs: {
      "src": _vm.coverUrl(_vm.topItem.image),
      "alt": _vm.topItem.name
    },
    on: {
      "error": _vm.onImageError
    }
  })]), _c('p', {
    staticClass: "w-full text-xs text-gray-500 truncate mb-0",
    attrs: {
      "title": _vm.topItem.author
    }
  }, [_vm._v(" " + _vm._s(_vm.topItem.author || '-') + " ")]), _c('p', {
    staticClass: "w-full text-sm font-medium text-gray-800 truncate mb-0",
    attrs: {
      "title": _vm.topItem.name
    }
  }, [_vm._v(" " + _vm._s(_vm.topItem.name || '-') + " ")])])]), _c('ul', {
    staticClass: "border-l border-gray-100 px-4 py-1 mb-0"
  }, _vm._l(_vm.otherRanks, function (rank) {
    return _c('li', {
      key: rank,
      staticClass: "flex items-start gap-3 py-2.5",
      class: {
        'border-b border-gray-100': rank < _vm.lastRank
      }
    }, [_c('span', {
      staticClass: "w-4 text-sm text-gray-500 pt-0.5"
    }, [_vm._v(_vm._s(rank))]), _c('div', {
      staticClass: "flex-1 min-w-0"
    }, [_c('p', {
      staticClass: "text-sm text-gray-800 truncate mb-0",
      attrs: {
        "title": _vm.itemAt(rank) ? _vm.itemAt(rank).name : ''
      }
    }, [_vm._v(" " + _vm._s(_vm.itemAt(rank) ? _vm.itemAt(rank).name || '-' : 'No Data Available') + " ")]), _c('p', {
      staticClass: "text-xs text-gray-500 mb-0"
    }, [_vm._v(" " + _vm._s(_vm.itemAt(rank) ? ((_vm.formatNumber(_vm.itemAt(rank).total)) + " " + (_vm.theme.unit)) : '-') + " ")])])]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }